import React from 'react'
import { motion } from 'framer-motion'
import VorteileLandingpage from '@/components/Motion/VorteileLandingpage'
import MapAutocomplete from '@/components/test/MapAutocompleteTest'
import AccordionImage from '@/components/test/accordion-image'
import CarouselTest from '@/components/test/Carousel'

export default function MotionTestPage() {
const images = [
  "/couple.jpg",
  "/JakobseBild.jpg",
  "/couple.jpg",
  "/JakobseBild.jpg",
  "/couple.jpg",
  "/JakobseBild.jpg",
  "/couple.jpg",
  "/JakobseBild.jpg",
  "/couple.jpg",
  "/JakobseBild.jpg",
  "/couple.jpg",
  "/JakobseBild.jpg",
]
  return (
    <div>
      <AccordionImage />
      <CarouselTest images={images}/>
    </div>
  )
}
